import React, { useCallback, useMemo, useState } from "react";
import Pagination from "components/Reusable/Grid/CoolGrid/Pagination.js";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";

const filesPerPage = 25;

const usePaginationUploader = () => {
  const { uploaderGetFiles } = useUploader();

  const [pageNum, setPageNum] = useState(1);

  const fileList = useMemo(() => {
    const start = 0;
    const end = start + filesPerPage * pageNum;
    return uploaderGetFiles().slice(start, end);
  }, [uploaderGetFiles(), pageNum]);

  const UplaoderPaginator = useCallback(
    ({ className }) => (
      <Pagination
        incFunc={() => {
          setPageNum(pageNum + 1);
        }}
        hasMore={uploaderGetFiles().length > pageNum * filesPerPage}
        className={className}
      />
    ),
    [pageNum, uploaderGetFiles().length]
  );

  return { fileList, UplaoderPaginator, pageNum };
};

export default usePaginationUploader;
